/**
 * The Home item as a round house badge rather than the word (owner, 1 Oct
 * 2026). Our own drawing, in the blue of the "Pale Blue Dot" wordmark
 * (#60a5fa, owner) with a white house (owner), in both themes; the link keeps "Home" as its accessible
 * name.
 */
export function HomeBadge() {
  return (
    <svg width="36" height="36" viewBox="0 0 30 30" aria-hidden className="block transition-transform duration-200 group-hover:scale-110 motion-reduce:transition-none">
      <circle cx="15" cy="15" r="15" fill="#60a5fa" />
      <path d="M8 14.6 15 8.5l7 6.1" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.4 10.7V8.6h1.9v3.8" fill="#ffffff" />
      <path d="M10.2 13.6V21.5h3.4v-4.3h2.8v4.3h3.4v-7.9L15 9.5Z" fill="#ffffff" />
    </svg>
  );
}
